import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'

export function useGetDrugCatalogItem(drugId: string | undefined) {
  return useQuery(queries.drugCatalog.getDrugCatalogItem(drugId || ''))
}
